import { Provider } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { WidgetRoutes as Routes } from './Routes';
import { store } from './store/store';

function App() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const themeName = queryParams.get('themeName');

  // const [theme, setTheme] = useState(theme1);

  // React.useEffect(() => {
  //   if (themeName) {
  //     import(`./styles/themes/${themeName}`)
  //       .then((module) => setTheme(module.default))
  //       .catch((error) => console.error(`Failed to load theme: ${error.message}`));
  //   }
  // }, [themeName]);

  return (
    <Provider store={store}>
      <Routes />
    </Provider>
  );
}

export default App;
